import TabsView from "@/common/components/tabs-view/tabs-view";
import React from "react";
import { menuMasterTabs } from "./constants/constants";

export default function ProductMaster() {
    return(
        <TabsView
            tabs={menuMasterTabs}
        />
    )
}